import type {Component} from 'typings/portaro.fe.types';

export default class PaginatedPanelListComponent implements Component<PaginatedPanelListComponentBindings> {
    public static componentName = 'kpPaginatedPanelList';

    public templateUrl = require('./paginated-panel-list.tpl.ftl');
    public transclude = true;
    public controllerAs = '$ctrl';
    public bindings = {
        pagination: '<'
    } as const;
}

interface PaginatedPanelListComponentBindings {
    pagination: any;
}
